import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<unknown, Error, { draftId: number }, boolean>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteProductDraftRequest = ({
  options,
}: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, { draftId: number }, boolean>(
    [Entities.ProductsDrafts, 'delete'],
    async ({ draftId }) => {
      const { data } = await api.v1AdminProductsDraftsDraftIdDelete(draftId)
      return data
    },
    {
      ...options,
    },
  )
}
